import { DialogTitle } from "@/kit/ui/dialog";
import { FormattedDataSize } from "@/components/FormattedDataSize";
import { FormattedMessage } from "react-intl";
import { useStateContext } from "./state";

const FilesDescriptor = () => {
  const { files } = useStateContext();
  if (files.length == 1) {
    const file = files[0];
    return (
      <span>
        {file.name} (<FormattedDataSize bytes={file.size} />)
      </span>
    );
  }
  return (
    <span>
      <FormattedMessage
        defaultMessage="Directory ({num, plural, one {# file} other {# files}})"
        values={{ num: files.length }}
      />
    </span>
  );
};

export const Title = () => {
  return (
    <DialogTitle>
      <div className="flex gap-2 flex-col">
        <h1 className="text-dxs font-semibold">
          <FormattedMessage defaultMessage="Upload Dataset" />
          <span className="text-grey-600 font-medium">
            {" · "}
            <FilesDescriptor />
          </span>
        </h1>
        <p className="text-grey-600 text-sm font-normal">
          <FormattedMessage defaultMessage="Review your dataset and make any necessary edits before proceeding." />
        </p>
      </div>
    </DialogTitle>
  );
};
